import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ISelectedInformation } from '../../interfaces/selected-information.interface';

@Component({
  selector: 'sgt-information-chip',
  templateUrl: './information-chip.component.html',
  styleUrls: ['./information-chip.component.scss'],
})
export class InformationChipComponent {
  @Input() information!: ISelectedInformation;
  @Output() removed = new EventEmitter<void>();
}
